/**
 * Los miembros de una membresía gratis, en su ficha.
 *
 * Unirse a una gratis es reclamarla (un pedido de 0), así que la tabla de
 * ventas la enseñaba como «pedidos de $0». Aquí se lee como lo que es: quién
 * se unió, cuándo y si sigue (o salió desde «Mi cuenta»).
 */
import { IconUsers } from '@tabler/icons-react'
import { useI18n } from '../../../lib/i18n'
import type { Order } from '../../../lib/api'

export function FreeMembersList({ orders, loading, onOpenContact }: {
  orders: Order[]
  loading: boolean
  onOpenContact?: ((contactId: string) => void) | undefined
}) {
  const { t, language } = useI18n()
  if (loading) return <div className="dash-free-members is-loading" aria-busy="true" />
  /* Una fila por persona: la última vez que se unió. */
  const latest = new Map<string, Order>()
  for (const order of [...orders].sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))) {
    const key = (order.buyerEmail ?? order.id).trim().toLowerCase()
    latest.set(key, order)
  }
  const rows = [...latest.values()].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
  const activeCount = rows.filter((row) => row.status === 'paid').length

  if (!rows.length) {
    return (
      <div className="dash-placeholder">
        <IconUsers size={34} aria-hidden="true" />
        <strong>{t('memberships.detail.emptyTitle.membership')}</strong>
        <span>{t('memberships.free.emptyBody')}</span>
      </div>
    )
  }
  const day = (value: string) => new Date(value).toLocaleDateString(language, { day: 'numeric', month: 'short', year: 'numeric' })
  return (
    <section className="dash-free-members">
      <header>
        <strong>{t('memberships.free.title')}</strong>
        <span>{t('memberships.free.count', { count: activeCount })}</span>
      </header>
      <ul>
        {rows.map((row) => {
          const email = (row.buyerEmail ?? '').trim().toLowerCase()
          const active = row.status === 'paid'
          const name = row.buyerName?.trim() || email || t('common.untitled')
          return (
            <li key={row.id}>
              {onOpenContact && email
                ? <button type="button" className="dash-free-members-name" onClick={() => onOpenContact(`email:${email}`)}>{name}</button>
                : <span className="dash-free-members-name">{name}</span>}
              <span className="dash-free-members-email">{row.buyerName?.trim() ? email : ''}</span>
              <span className="dash-free-members-date">{t('memberships.free.since', { date: day(row.createdAt) })}</span>
              <span className={`dash-offer-status dash-offer-status-compact is-${active ? 'active' : 'archived'}`}>{t(active ? 'memberships.free.active' : 'memberships.free.left')}</span>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
